var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaveD2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 462,
    height: 393,
    viewBox: "0 0 462 393",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.799 27.2984C342.231 33.6686 356.805 41.3128 370.951 50.2311C465.683 108.837 525.695 223.075 508.12 332.218C490.116 443.059 371.808 600.614 254.786 623.547C216.635 631.191 177.628 620.574 140.335 609.108C77.7517 589.997 19.0262 558.996 -42.6999 541.159C-66.7045 534.364 -92.8524 532.666 -116 542.009C-156.293 558.146 -166.152 592.97 -183.298 628.218C-202.588 668.138 -235.165 701.688 -274.601 722.497C-355.617 764.965 -460.208 745.005 -535.223 699.14C-646.673 631.191 -686.537 497.417 -649.673 375.959C-640.243 344.533 -625.24 313.532 -600.378 291.448C-557.941 253.227 -494.072 246.432 -438.347 260.447C-399.768 270.214 -364.619 288.9 -331.184 309.285C-303.75 326.272 -278.459 349.629 -244.596 349.629C-176.011 350.054 -155.007 262.57 -133.146 213.732C-104.426 149.181 -55.9881 92.6989 4.02334 54.9025C100.899 -6.67584 221.351 -17.2928 326.799 27.2984Z",
    fill: "url(#paint0_linear_101_590)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.836 27.5566C342.26 33.9254 356.827 41.5681 370.966 50.4845C465.654 109.078 525.638 223.293 508.071 332.414C490.076 443.232 371.823 600.756 254.855 623.684C216.723 631.326 177.734 620.712 140.458 609.248C77.9042 590.141 19.2061 559.146 -42.4912 541.313C-66.4845 534.519 -92.6202 532.821 -115.757 542.162C-156.031 558.297 -165.886 593.113 -183.024 628.354C-202.304 668.266 -234.867 701.809 -274.284 722.614C-355.262 765.073 -459.805 745.117 -534.784 699.261C-646.182 631.326 -686.028 497.58 -649.181 376.147C-639.755 344.727 -624.759 313.732 -599.909 291.653C-557.492 253.439 -493.653 246.646 -437.954 260.658C-399.393 270.423 -364.26 289.105 -330.84 309.486C-303.419 326.469 -278.141 349.822 -244.293 349.822C-175.74 350.246 -154.746 262.781 -132.895 213.952C-104.188 149.414 -55.7732 92.9437 4.21026 55.155C101.041 -6.41081 221.436 -17.0256 326.836 27.5566Z",
    fill: "url(#paint1_radial_101_590)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-682.68 899.588C-876.431 754.773 -763.267 435.839 -576.802 338.163C-506.932 301.641 -425.488 287.626 -347.044 297.819C-276.316 307.161 -188.014 330.943 -115.571 303.764C-60.7037 282.955 -35.4132 231.569 -6.69338 184.854C73.0362 54.9025 274.075 30.6958 373.951 153.853C410.815 199.293 425.818 262.57 407.814 318.203C365.378 447.305 223.065 392.097 142.478 461.32C110.329 488.924 101.756 544.132 82.8952 581.079C63.6058 618.875 40.0298 654.973 14.7393 689.372C-38.4137 761.992 -103.14 828.242 -177.726 879.628C-326.469 982.4 -512.504 1012.98 -669.82 908.931C-674.107 905.958 -678.393 902.985 -682.68 899.588Z",
    fill: "url(#paint2_linear_101_590)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-682.68 899.588C-876.431 754.773 -763.267 435.839 -576.802 338.163C-506.932 301.641 -425.488 287.626 -347.044 297.819C-276.316 307.161 -188.014 330.943 -115.571 303.764C-60.7037 282.955 -35.4132 231.569 -6.69338 184.854C73.0362 54.9025 274.075 30.6958 373.951 153.853C410.815 199.293 425.818 262.57 407.814 318.203C365.378 447.305 223.065 392.097 142.478 461.32C110.329 488.924 101.756 544.132 82.8952 581.079C63.6058 618.875 40.0298 654.973 14.7393 689.372C-38.4137 761.992 -103.14 828.242 -177.726 879.628C-326.469 982.4 -512.504 1012.98 -669.82 908.931C-674.107 905.958 -678.393 902.985 -682.68 899.588Z",
    fill: "url(#paint3_radial_101_590)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_590",
    x1: -728.634,
    y1: 760.404,
    x2: 888.396,
    y2: -131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDF00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_101_590",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-70.4694 -115.209) rotate(79.6257) scale(1313.6 1235.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5576,
    stopColor: "#EC4C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#D60B52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_101_590",
    x1: 392.451,
    y1: -466.926,
    x2: -635.497,
    y2: 1192.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9370"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_101_590",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.5121 145.069) rotate(-122.724) scale(1401.84 2365.81)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5576,
    stopColor: "#EC4C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#D60B52"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 511,
    height: 393,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveD2);
export default __webpack_public_path__ + "static/media/wave_d2.e4c25fa8f7a724093f0b77f07649fd73.svg";
export { ForwardRef as ReactComponent };